import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyLogoutPage = loadable(
  () =>
    import(
      /* webpackChunkName: "content/logout" */
      './LogoutPage'
    ),
);
